import React from 'react';
import * as Routes from '@/modules/routes';
import { Games as GameIcon } from '@/../images/react/Games';
import { Biographies as BiographiesIcon } from '@/../images/react/Biographies';
import { Assessments as AssessmentsIcon } from '@/../images/react/Assessments';
import { VideoActivity as VideoActivityIcon } from '@/../images/react/VideoActivity';
import { Lesson } from '@/types/api/LessonOverview';

// AIDEV-TODO: these library nav cards are still hardcoded, so a new library gets no card — assign/grade
// went data-driven in PLAT-14851 and the lesson overview API could supply these the same way.
// AIDEV-NOTE: primarySourceObj links to tag 'Civics Library', not 'Primary Source Library'. Pre-existing
// bug, left alone here so it is not silently fixed inside an unrelated change.
type LibrariesObjProps = {
  programId: number;
  lesson: Lesson;
  unitId: number;
  civicsLibrary: boolean;
  primarySourceLibrary: boolean;
};

const librariesUtils = ({ programId, lesson, unitId, civicsLibrary, primarySourceLibrary }: LibrariesObjProps) => {
  const civicsLibraryObj = {
    icon: <BiographiesIcon aria-hidden fill="#555555" height="100%" width="100%" />,
    path: Routes.shared_program_reference_materials_path(programId, { tag: 'Civics Library' }),
    title_tag: 'civics_library',
  };

  const primarySourceObj = {
    icon: <BiographiesIcon aria-hidden fill="#555555" />,
    path: Routes.shared_program_reference_materials_path(
      programId, { tag: 'Civics Library' },
    ),
    title_tag: 'primary_sources',
  };

  const libraryCards = [
    {
      icon: <VideoActivityIcon aria-hidden fill="#555555" />,
      path: Routes.shared_program_videos_path({ id: programId }),
      title_tag: 'videos',
    },
    lesson.lessonGameAssignables?.length > 0 && {
      icon: <GameIcon aria-hidden fill="#555555" />,
      path: Routes.library_shared_program_games_path({ id: programId }),
      title_tag: 'games',
    },
    {
      icon: <BiographiesIcon aria-hidden fill="#555555" />,
      path: Routes.shared_program_reference_materials_path(
        programId, { selected_unit_id: unitId, tag: 'Biographies' },
      ),
      title_tag: 'biographies',
    },
    {
      icon: <AssessmentsIcon aria-hidden fill="#555555" />,
      path: Routes.library_shared_program_assessments_path(
        programId, { lesson_id: lesson.id, unit_id: unitId },
      ),
      title_tag: 'assessments',
    },
  ].filter(Boolean);

  if (civicsLibrary) libraryCards.push(civicsLibraryObj);
  if (primarySourceLibrary) libraryCards.push(primarySourceObj);

  return libraryCards;
};

export default librariesUtils;
